import { render, staticRenderFns } from "./oldServiceSet.vue?vue&type=template&id=72d6f496&scoped=true&"
import script from "./oldServiceSet.vue?vue&type=script&lang=js&"
export * from "./oldServiceSet.vue?vue&type=script&lang=js&"
import style0 from "./oldServiceSet.vue?vue&type=style&index=0&id=72d6f496&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d6f496",
  null
  
)

export default component.exports